import { PaymentMethod } from "./entity/order";
import { Variant } from './entity/live';

export const PointType = {
  "FREE": 0,
  "PAID": 1
}

type BroadcastType = {
  [key: string]: 0 | 1;
};

export const BROADCAST_TYPE: BroadcastType = {
  immediate: 0,
  scheduled: 1
} as const;

type PointFluctKintType = {
  [key: string]: number | string;
};

export const POINT_FLUCT_KIND_LIST: PointFluctKintType[] = [
  {
    id: 1,
    name: "use_gift",
    default_text: "ギフト送付"
  },
  {
    id: 98,
    name: "withdraw",
    default_text: "退会により失効"
  },
  {
    id: 99,
    name: "expired",
    default_text: "有効期限切れにより失効"
  },
  {
    id: 101,
    name: "charge",
    default_text: "ポイントチャージ"
  },
  {
    id: 199,
    name: "return",
    default_text: "ポイント返還"
  }
];


type DeviceType = {
  [key: string]: number | string;
};

export const DEVICE_TYPE_LIST: DeviceType[] = [
  {
    name: "web",
    value: "WEB"
  },
  {
    name: "Android",
    value: "ANDROID"
  },
  {
    name: "iOS",
    value: "IOS"
  }
];

type OrderStatusType = {
  [key: string]:  string;
};

export const ORDER_STATUS_LIST: OrderStatusType[] = [
  {
    name: "INIT",
    default_text: "初期状態"
  },
  {
    name: "CREATED_STRIPE_SESSION",
    default_text: "STRIPE決済前"
  },
  {
    name: "EXPIRED_STRIPE_SESSION",
    default_text: "STRIPE決済期限切れ"
  },
  {
    name: "COMPLETED",
    default_text: "決済成功"
  },
  {
    name: "FAILED",
    default_text: "決済失敗"
  }
];

export const PAYMENT_METHOD_LIST: PaymentMethod[] = [
  'STRIPE',
  'APP_STORE',
  'GOOGLE_PLAY'
]

export const VARIANTS: Variant[] = [
  { value: 'auto', label: '自動' },
  { value: '240p_64k', label: '低', prefix: '_2' },
  { value: '480p_128k', label: '中', prefix: '_1' },
  { value: '1080p_192k', label: '高', prefix: '_0' },
]

export enum PUBLIC_STATUS {
  public =  "PUBLIC",
  private = "PRIVATE",
}
